import { render, staticRenderFns } from "./BClient.vue?vue&type=template&id=47897dc9&scoped=true&"
import script from "./BClient.vue?vue&type=script&lang=js&"
export * from "./BClient.vue?vue&type=script&lang=js&"
import style0 from "./BClient.vue?vue&type=style&index=0&id=47897dc9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47897dc9",
  null
  
)

export default component.exports